import { formatDate } from "@progress/kendo-intl";
import dayjs from "dayjs";
import { useEffect, useRef, useState } from "react";
import DatePicker from "react-datepicker";
import { LoadingIndicator } from "../../../core/loading-indicator.component";
import { Grid, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import {
  ExcelExport,
  ExcelExportColumn,
} from "@progress/kendo-react-excel-export";
import { useGetSessions } from "../../../apiclient/master/useGetSessionApi";
import { SelectField } from "../../../core/select-field.component";
import { Form, Formik } from "formik";
import { getDataWithToken, getEndPoint } from "../../../Utils/network.client";
import { API_END_POINT } from "../../../constants";
import axios from "axios";
import MilkAcknowlegementModel from "../../../models/reports/milkacknowlegement-reports";
import { PDFExport } from "@progress/kendo-react-pdf";
import { useGetCompanyDetails } from "../../../apiclient/master/useGetCompanydetailsApi";

interface IMilkAcknowledgmentReport {}

export const MilkAcknowledgmentReport: React.FC = () => {
  const [reportMenu, setReportMenu] = useState<IMilkAcknowledgmentReport[]>([]);
  const [sessionData, setSessionData] = useState<
    { value: string; label: string }[]
  >([]);
  const { data: fetchedSession } = useGetSessions();
  const [selectedSessionName, setSelectedSessionName] = useState<string>("");
  const [fromDate, setFromDate] = useState<Date>(
    new Date(dayjs().add(0, "months").format("MM/DD/YYYY"))
  );
  const { data: companyDetails, isLoading: isCompanyLoading } =
    useGetCompanyDetails();
  const companyName = companyDetails?.[0]?.companyName || "Company Name";

  const [session, setsession] = useState<Date>(new Date());
  const [sessionId, setsessionId] = useState(0);

  const [MilkAcknowlegementList, setMilkAcknowlegementList] = useState<
    MilkAcknowlegementModel[]
  >([]);

  const exportExcel = useRef<ExcelExport | null>(null);
  const pdfExportRef = useRef<PDFExport | null>(null);

  const excelExportRef = useRef<ExcelExport | null>(null);

  const exportToExcel = () => {
    if (!exportExcel.current) return;

    const options = exportExcel.current.workbookOptions();
    const sheet = options.sheets[0];

    const formattedFromDate = fromDate
      ? new Date(fromDate).toLocaleDateString("en-IN", {
          day: "numeric",
          month: "numeric",
          year: "numeric",
        })
      : "";

    const headingWithDate =
      `Milk Acknowledgment Report - ${formattedFromDate}` +
      (selectedSessionName ? ` - ${selectedSessionName}` : "");

    // Add a single merged heading row with the full string
    sheet.rows.unshift({
      cells: [
        {
          value: headingWithDate,
          colSpan: sheet.columns.length,
          bold: true,
          fontSize: 14,
          textAlign: "center",
        },
      ],
    });
    sheet.rows.unshift({
      cells: [
        {
          value: companyName,
          colSpan: sheet.columns.length,
          bold: true,
          fontSize: 14,
          textAlign: "center",
        },
      ],
    });

    exportExcel.current.save(options);
  };
  const exportToPDF = () => {
    if (pdfExportRef.current) {
      pdfExportRef.current.save();
    }
  };

  useEffect(() => {}, [reportMenu]);

  useEffect(() => {
    if (fetchedSession) {
      const mappedSession = fetchedSession.map((session: any) => ({
        value: session.sessionId,
        label: session.name,
      }));
      setSessionData(mappedSession);
    }
  }, [fetchedSession]);

  // const date = fromDate;
  // // Format date as yyyy-mm-dd
  // const formattedDate = date.toISOString().split('T')[0];

  // console.log("fromdate", formattedDate);

  const getMilkAcknowlegementList = async () => {
    try {
      const formattedFromDate = dayjs(fromDate).format("YYYY-MM-DD");
      const response = await getDataWithToken<any>(
        `${getEndPoint(
          API_END_POINT.REPORT
        )}/api/DailyReportsService/GetMilkAcknowledgement/${formattedFromDate}/${sessionId}`
      );

      // const getMilkAcknowlegementUrl = getEndPoint(API_END_POINT.REPORT) + "/api/DailyReportsService/GetMilkAcknowledgement";
      // const response = await axios.get(getMilkAcknowlegementUrl, {
      //     params: {
      //         scheduledate: fromDate,
      //         sess: sessionId
      //     },
      // });

      //alert(JSON.stringify(response.data.result));

      const milkAcknowlwgement = response?.data?.result || [];

      console.log("milkAcknowlwgement", milkAcknowlwgement);
      setMilkAcknowlegementList(milkAcknowlwgement);
      //setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      //setShowGrid(false);
    }
  };
  const handleMilkAcknowlegementChange = (value: any) => {
    setsessionId(value);
    const selectedSession = sessionData.find(
      (session) => session.value === value
    );
    setSelectedSessionName(selectedSession?.label || ""); // Assuming label holds the display name
    console.log("Selected session ID:", value);
  };

  const initialValues = {
    sessionId: "", // default empty value for zone
    fromDate: fromDate,
  };
  const hasRecords = MilkAcknowlegementList.length > 0;

  let grid = (
    <Grid
      data={MilkAcknowlegementList}
      // pageable={{ pageSizes: [10, 20, 50, 100] }}
      total={null}
      groupable={false}
      sortable={true}
      onDataStateChange={null}
      onExpandChange={null}
      expandField="expanded"
      columnVirtualization={false}
      resizable={true}
    >
      <GridColumn
        title="S.No"
        cell={(props) => {
          const index = props.dataItem
            ? MilkAcknowlegementList.indexOf(props.dataItem) + 1
            : 0;
          return <td>{index}</td>;
        }}
      />
      <GridColumn field="mgName" title="Main Group" columnMenu={null} />
      <GridColumn field="sgName" title=" Sub Group" columnMenu={null} />
      <GridColumn
        field="displayOrder"
        title="Display Order"
        columnMenu={null}
      />
      <GridColumn field="productShortName" title="Product Short Name" />
      <GridColumn field="unitQty" title="Unit Qty" />
      <GridColumn field="packets" title="Packets" />
      <GridColumn field="litre" title="Litre" />

      <GridNoRecords>
        <div className="mt-2" style={{ width: "100%", height: "500px" }}>
          <center>
            <h5>No data found</h5>
          </center>
        </div>
      </GridNoRecords>
    </Grid>
  );

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={(values) => {
        console.log("Form submitted with values: ", values);
      }}
    >
      {({ setFieldValue, values }) => (
        <Form>
          <div
            className="m-lg-3 mt-lg-1 m-4 card p-3 border-0 m-3 sw-shadow radius-15"
            style={{ minHeight: "500px" }}
          >
            <div className="top-sec-align row">
              <center>
                <h4 className="text-normal title-web mb-0 report-title-color">
                  Milk Acknowledgment Report
                </h4>
              </center>
            </div>
            <div className="fade_rule"></div>
            <div className="d-flex justify-content-between mt-4 pt-3 pb-3">
              {/* <div>
                                <label>Search</label>
                                <input
                                    type="text"
                                    className="form-control ms-auto search-right-align searchBg"
                                />
                            </div> */}
              <div className="d-flex">
                <div className="me-2">
                  <label> Select Date</label>
                  <DatePicker
                    selectsMultiple={true}
                    openToDate={new Date()}
                    className="form-control ms-auto search-right-align calendarBg"
                    value={formatDate(fromDate, "dd/MM/yyyy")}
                    placeholderText="To"
                    dateFormat={"dd/MM/yyyy"}
                    onChange={([date]: any) => {
                      setFromDate(date);
                    }}
                  />
                </div>
                <div className="me-2">
                  <label> Select Session </label>
                  <SelectField
                    name="sessionId" // Matching field name with Formik's initialValues
                    options={sessionData}
                    unSelectValue={0}
                    notifyChange={handleMilkAcknowlegementChange} // Unselected state as empty string
                    // setFieldValue={setFieldValue} // Pass `setFieldValue` from Formik
                  />

                  {/* <SelectField
                                        name="sessionId"
                                        options={sessionData}
                                        unSelectValue={0}
                                        notifyChange={handleMilkAcknowlegementChange}
                                    /> */}
                </div>
                <div>
                  <label></label>
                  <button
                    className="btn-primary btn search-btns mt-4"
                    onClick={() => {
                      getMilkAcknowlegementList();
                    }}
                    type="submit"
                  >
                    <svg width="17" height="17" viewBox="0 0 17.5 17.5">
                      <path
                        id="Path_magnify"
                        data-name="Path / magnify"
                        d="M9.5,3a6.5,6.5,0,0,1,4.94,10.73l.27.27h.79l5,5L19,20.5l-5-5v-.79l-.27-.27A6.5,6.5,0,1,1,9.5,3m0,2A4.5,4.5,0,1,0,14,9.5,4.481,4.481,0,0,0,9.5,5Z"
                        transform="translate(-3 -3)"
                        fill="#fff"
                      />
                    </svg>
                  </button>
                </div>
                <div className="d-flex justify-content-end">
                  <button
                    title="Export Excel"
                    className="export-button ms-2"
                    onClick={exportToExcel}
                    disabled={!hasRecords}
                    style={{ marginTop: "23px", marginBottom: "17px" }}
                  >
                    Export to Excel
                  </button>
                  <button
                    title="Export Excel"
                    className="export-button ms-2"
                    onClick={exportToPDF}
                    disabled={!hasRecords}
                    style={{ marginTop: "23px", marginBottom: "17px" }}
                  >
                    Export to PDF
                  </button>
                </div>
              </div>
            </div>
            <div className="row col=12">
              <div>
                {/* <div className="top-sec-align row">
                                    <div className="d-flex justify-content-end">
                                        <button title="Export Excel" className="btn m-2" onClick={excelExport}>
                                            Export to Excel
                                        </button>
                                        <button
                                            title="Refresh list"
                                            className="btn two m-2"
                                            onClick={exportToPDF}
                                        >
                                            Export to PDF
                                        </button>
                                    </div>
                                </div> */}
                <LoadingIndicator isLoading={false} />
                <PDFExport
                  fileName={"Milk_Acknowlegement.pdf"}
                  ref={pdfExportRef}
                  title="Milk"
                >
                  <div style={{ padding: "10px", backgroundColor: "#fff" }}>
                    {/* Company Name */}
                    <div style={{ textAlign: "center", marginBottom: "5px" }}>
                      <span style={{ fontWeight: "bold", fontSize: "1.5rem" }}>
                        {companyDetails?.[0]?.companyName || "Company Name"}
                      </span>
                    </div>
                    <div style={{ textAlign: "center", marginBottom: "10px" }}>
                      <span style={{ fontWeight: "bold", fontSize: "1.25rem" }}>
                        Milk Acknowledgment Report
                        {fromDate && (
                          <>
                            {" - "}
                            {new Date(fromDate).toLocaleDateString("en-IN", {
                              year: "numeric",
                              month: "numeric",
                              day: "numeric",
                            })}
                          </>
                        )}
                        {selectedSessionName && ` - ${selectedSessionName}`}
                      </span>
                    </div>

                    {grid}
                  </div>

                  <ExcelExport
                    fileName={"MilkAcknowlegement_List"}
                    data={MilkAcknowlegementList}
                    ref={exportExcel}
                  >
                    <ExcelExportColumn
                      width={100}
                      field="mgName"
                      title="Main Group"
                    />
                    <ExcelExportColumn
                      width={100}
                      field="sgName"
                      title="Sub Group"
                    />
                    <ExcelExportColumn
                      width={150}
                      field="displayOrder"
                      title="Display Order"
                    />
                    <ExcelExportColumn
                      width={150}
                      field="productShortName"
                      title="Product Short Name"
                    />
                    <ExcelExportColumn
                      width={150}
                      field="unitQty"
                      title="Unit Qty  "
                    />

                    <ExcelExportColumn
                      width={150}
                      field="packets"
                      title="Packets"
                    />

                    <ExcelExportColumn
                      width={150}
                      field="litre"
                      title="Litre"
                    />
                  </ExcelExport>
                </PDFExport>
              </div>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};
